import { Navigate } from "react-router-dom";

function PrivateRoute({ element, allowedRoles = [] }) {
  const isAuthenticated = sessionStorage.getItem("seepilUserID");
  const userType = sessionStorage.getItem("seepilUserType");

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(userType)) {
    const redirectPath = userType === "admin" ? "/admin/dashboard" : "/cliente/dashboard";
    return <Navigate to={redirectPath} />;
  }

  return <>{element}</>;
}

export default PrivateRoute;
